import { SettingsRoutes } from 'pages/settings/route/type'
import { RcsRoutes } from 'pages/settings/pages/rcs/route/type'

const rcs = `/${SettingsRoutes.root}/${RcsRoutes.root}`

export const RcsPath = {
  root: rcs,
  create: `${rcs}/${RcsRoutes.create}`,
}
